import React, { useEffect, useState } from "react";
import _ from "lodash";
import { useRouteMatch } from "react-router-dom";

import { ERROR_MESSAGE_UNEXPECTED_ERROR } from "../../../../utils/consts";
import DefaultAlert from "../../../../components/alerts/DefaultAlert";
import Authorities from "../../../../auth/authorities";
import withAuthority from "../../../../components/Auth/withAuthority";
import { Box, Hidden } from "@material-ui/core";
import PageHeaderMobile from "../../../../components/common/PageHeader/PageHeaderMobile";
import MetricsNode from "./MetricsNode";

// 🔥 Firebase imports
import firebase from "firebase";
import { secondaryDb } from "../../../../utils/firebase/temp";
import {
  fetchCustomerInfoUsingLocationId,
  fetchDisplayInfo,
  getLayout,
  getSingleLayout,
} from "../../../../services/insightApp/metrics";

/**
 * MetricsListShowPageNew Component
 *
 * This component fetches and displays real-time metrics from Firebase
 * based on the selected locationId and updates automatically on DB changes.
 */
const MetricsListShowPageNew: React.FunctionComponent<{}> = () => {
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [clientId, setClientId] = useState("");
  const [layoutDetails, setLayoutDetails] = useState<any>([]);

  const match: any = useRouteMatch();
  const locationId = match?.params?.locationId;
  const layoutId = match?.params?.layoutId;

  const getCustomerInfo = async () => {
    try {
      // Retrieve the idToken from cookies
      // Fetch all locations using the idToken
      const res = await fetchCustomerInfoUsingLocationId(locationId);
      if (res?.data?.data?.clientId) {
        const clientIdFromApi = res.data.data.clientId;
        setClientId(clientIdFromApi);
      }
    } catch (error) {
      setError("Please try again later.");
    }
  };

  useEffect(() => {
    document.title = "Insight - Dashboard";

    getCustomerInfo();
  }, [locationId]);

  const getLayoutInfo = async () => {
    try {
      // Retrieve the idToken from cookies
      // Fetch all locations using the idToken
      const res = await getSingleLayout(locationId, layoutId);
      setLayoutDetails(res.data.data);
      setIsLoading(false);
      //   if (res?.data?.data?.clientId) {
      //     const clientIdFromApi = res.data.data.clientId;
      //     setClientId(clientIdFromApi);
      //   }
    } catch (error) {}
  };

  useEffect(() => {
    getLayoutInfo();
  }, []);
  return (
    <>
      <Hidden lgUp>
        <PageHeaderMobile />
      </Hidden>
      <Box style={{ marginTop: "18px" }}>
        <MetricsNode
          layoutDetails={layoutDetails}
          isLoading={isLoading}
          clientId={clientId}
          // locationMetricsNode={locationMetricsNode}
          // stationMetricsNode={stationMetricsNode}
        />
      </Box>
      <DefaultAlert
        open={!!error}
        handleClose={() => setError("")}
        message={error}
        severity="error"
      />
    </>
  );
};

export default MetricsListShowPageNew;
